// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1sLsY","search":"Settings_search__139QH","filter":"Settings_filter__2QuLd"};